export function MemberConsultant() {
  return <div>Consultant 페이지</div>;
}
